import type { CloseIntent } from "~/features/addToCart/flow/useAtcFlowController";

export function createAddToCartCloseIntentAdapter(close: () => void, onCancelCallback?: () => void) {
  return (intent: CloseIntent) => {
    close();

    if (intent === "closeAndRestorePrevious" && onCancelCallback) {
      onCancelCallback();
    }
  };
}

export function createEditPartCloseIntentAdapter(close: () => void) {
  return (_intent: CloseIntent) => close();
}
